import React from 'react';
import { useInstance } from '../contexts/InstanceContext';
import { PARTICIPANT_VIEWS, viewModuleFor } from '../config/participantViews';

/**
 * What a family route (/impactpath, /pivotpoints, /ratkaisut) is for this instance: the
 * version of the module its chain uses (#685). Changing the module in the flow
 * builder changes the route for everyone at once. The version URLs
 * (/impactmap, /pivotpoints-v1, /pivotpoints-v2) stay direct links to each.
 */
export default function ModuleRoute({ family, ...props }) {
  const { participantChain, participantChainError, instanceId } = useInstance();
  // Wait for the chain rather than flash the wrong version
  if (instanceId && !participantChain && !participantChainError) return null;
  const moduleId = viewModuleFor(participantChain, family);
  const View = PARTICIPANT_VIEWS[moduleId];
  if (!View) return null;
  return (
    <React.Suspense fallback={null}>
      <View {...props} />
    </React.Suspense>
  );
}
